"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-two/sections/healthSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

type HomeTwoHealthSectionTrailImagesItem = {
    /** Detected variants: "/Templates/Doccure/img/about/health-03.jpg`" | "/Templates/Doccure/img/about/health-04.jpg`" | "/Templates/Doccure/img/about/health-05.jpg`" */
    src: string;
    /** Detected variants: "health-03.jpg" | "health-04.jpg" | "health-05.jpg" */
    text: string;
    /** Detected variants: "health" */
    alt?: string;
};

type HomeTwoHealthSectionAvatarImagesItem = {
    /** Detected variants: "/Templates/Doccure/img/about/patient24.jpg`" | "/Templates/Doccure/img/about/patient25.jpg`" | "/Templates/Doccure/img/about/patient26.jpg`" | "/Templates/Doccure/img/about/patient27.jpg`" */
    src: string;
    /** Detected variants: "patient24.jpg" | "patient25.jpg" | "patient26.jpg" | "patient27.jpg" */
    text: string;
    /** Detected variants: "health" */
    alt?: string;
};
export type HomeTwoHealthSectionGeneratedProps = {
    trailImages?: HomeTwoHealthSectionTrailImagesItem[];
    avatarImages?: HomeTwoHealthSectionAvatarImagesItem[];
    sectionDiv0Div0ClassName?: string;
    /** Default: "From common illnesses to chronic disease management, we deliver" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    /** Default: "personalized care designed to improve your long-term health." */
    sectionDiv0Div0Div0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "health" */
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/health-01.jpg" */
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "health" */
    sectionDiv0Div0Div0Div0H20Span2ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/health-02.jpg" */
    sectionDiv0Div0Div0Div0H20Span2ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0H20Span2ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0H20Span2ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20Span2ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/doctor-bg-01.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-05.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
};

const HomeTwoHealthSectionGenerated: FC<HomeTwoHealthSectionGeneratedProps> = ({
    trailImages = [],
    avatarImages = [],
    sectionDiv0Div0Div0Div0H20H2Text = "From common illnesses to chronic disease management, we deliver",
    sectionDiv0Div0Div0Div0H20H2Text2 = "personalized care designed to improve your long-term health.",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageAlt = "health",
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/health-01.jpg",
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0H20Span2ImageWithBasePath0ImageAlt = "health",
    sectionDiv0Div0Div0Div0H20Span2ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/health-02.jpg",
    sectionDiv0Div0Div0Div0H20Span2ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0H20Span2ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0H20Span2ImageWithBasePath0ImageProps,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/doctor-bg-01.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "bg",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/banner-05.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    sectionDiv0Div0ClassName,
}) => {
    return (
        <section className="section health-section trail-content">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row"}>
                    <div className="col-lg-10 mx-auto">
                        {trailImages.map((src, idx) => (
                            <div
                                key={idx}
                                className="content-img"
                            >
                                <div className="content-img-single">
                                    <SmartImage
                                        src={src.src}
                                        className="img-fluid"
                                        alt={src.alt ?? "health"}
                                    />
                                </div>
                            </div>
                        ))}
                        <div className="health-content">
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>
                                    <span className="health-img">
                                        {renderNode(sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                    </span>
                                    {" "}
                                    {sectionDiv0Div0Div0Div0H20H2Text}
                                    {" "}
                                    <span className="avatar-list-stacked avatar-group-lg">
                                        {avatarImages.map((src, idx) => (
                                            <span className="avatar" key={idx}>
                                                <SmartImage
                                                    src={src.src}
                                                    alt={src.alt ?? "patient"}
                                                    className="img-fluid rounded-circle"
                                                />
                                            </span>
                                        ))}
                                    </span>
                                    {" "}
                                    {sectionDiv0Div0Div0Div0H20H2Text2}
                                    {" "}
                                    <span className="health-img">
                                        {renderNode(sectionDiv0Div0Div0Div0H20Span2ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0H20Span2ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={sectionDiv0Div0Div0Div0H20Span2ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0H20Span2ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0Div0Div0H20Span2ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                    </span>
                                </h2>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid health-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid health-bg-02" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeTwoHealthSectionGenerated;
